import React from "react";
import Navbar from "../home/Navbar/Navbar";
import Footer from "../Footer/Footer";

export default function AboutPage() {
	return (
		<div className="min-h-screen flex flex-col bg-gray-50 text-gray-800">
			<Navbar />

			{/* Hero Section */}
			<section className="mt-[180px] w-full bg-white py-16 px-6 sm:px-10 lg:px-20">
				<div className="max-w-5xl mx-auto text-center">
					<h1 className="text-4xl sm:text-5xl font-bold mb-6 font-americana">
						About Us
					</h1>
					<p className="text-gray-600 text-lg leading-relaxed max-w-3xl mx-auto">
						With over 40 years of combined business experience, outstanding
						customer service and knowledgeable sales staff, Azure always offers
						you the most fashion-forward gowns along with the traditional,
						exquisite styles for all of your occasions.
					</p>
				</div>
			</section>

			{/* Info Blocks */}
			<section className="bg-gray-100 py-12 px-6 sm:px-10 lg:px-20">
				<div className="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-10 items-center">
					<div className="space-y-6">
						<div className="bg-white p-6 rounded-2xl shadow">
							<p className="text-gray-700 leading-relaxed">
								We are excited to be part of your most memorable event, whether
								it is a special occasion or your exciting prom party. We have a
								magnitude of gowns to ensure you will look amazing on your
								special day.
							</p>
						</div>
						<div className="bg-white p-6 rounded-2xl shadow">
							<p className="text-gray-700 leading-relaxed">
								With a large network of retailers, we can assure you will find
								our gowns at a location near you.
							</p>
						</div>
						<div className="bg-white p-6 rounded-2xl shadow">
							<p className="text-gray-700 leading-relaxed">
								We promise you On-Time delivery and outstanding customer service
								at any of our retail partner’s locations.
							</p>
						</div>
					</div>

					<div className="relative">
						<div className="h-[700px] rounded-2xl overflow-hidden shadow-lg">
							<img
								src="https://demo.riskydress.com/images/2026/AZURE/A10031%20%282%29.png"
								alt="Azure Gowns"
								className="w-full h-full object-cover object-top"
							/>
						</div>
						<div className="absolute bottom-4 right-4 bg-indigo-600 text-white px-4 py-2 rounded-xl shadow-md font-medium">
							A10031
						</div>
					</div>
				</div>
			</section>

			{/* Mission Section */}
			<section className="bg-white py-16 px-6 sm:px-10 lg:px-20">
				<div className="max-w-5xl mx-auto text-center">
					<h2 className="text-3xl sm:text-4xl font-semibold mb-6 font-poppins">
						Welcome to the Most Dramatic Collection
					</h2>
					<p className="text-gray-600 text-lg leading-relaxed max-w-3xl mx-auto">
						Our mission is to provide the ultimate in fashion, fit and service.
					</p>
				</div>

				<div className="max-w-6xl mx-auto mt-10 grid grid-cols-1 lg:grid-cols-2 gap-10 items-center">
					<div className="bg-gray-100 rounded-2xl p-8 shadow-inner">
						<p className="text-gray-700 leading-relaxed">
							Azure will offer you the highest level of quality and design in
							all of our gowns with a fit that makes every woman look and feel
							beautiful.
						</p>
					</div>

					<div className="bg-gray-100 rounded-2xl p-8 shadow-inner">
						<p className="text-gray-700 leading-relaxed">
							Dramatic ballgowns, printed florals, oversized ruffles, crystal
							embellishments, cutout backs, strappy-trim, cutout skirts,
							oversize watercolors, beaded matte-jersey, and sexy shorts will
							make heads turn!
						</p>
					</div>
				</div>
			</section>

			{/* Highlights Section */}
			<section className="bg-indigo-600 py-16 px-6 sm:px-10 lg:px-20 text-white text-center">
				<h2 className="text-3xl font-semibold mb-10 font-poppins">We Offer</h2>
				<div className="max-w-4xl mx-auto grid grid-cols-2 sm:grid-cols-3 md:grid-cols-5 gap-6">
					{["Fashion", "Value", "Quality", "Sizing", "Selection"].map(
						(item) => (
							<div
								key={item}
								className="bg-white text-indigo-600 py-4 rounded-xl font-medium shadow hover:scale-105 transition-transform">
								{item}
							</div>
						)
					)}
				</div>
			</section>

			<Footer />
		</div>
	);
}
